import Vue from 'vue'
import Router from 'vue-router'
import Login from "@/views/login.vue"
import CommonView from "@/views/CommonView.vue"
import IndexView from "@/views/IndexView"
import HomeView from "@/views/HomeView"
import ApproveFailedListView from "@/views/ApproveFailedListView"
import UploadView from "@/views/InformationEntryView"
import CategoryView from "@/views/CategoryView.vue"
import CategoryItemView from "@/views/CategoryItemView.vue"
import KnowledgeView from "@/views/KnowledgeView.vue"
import UserClassifyView from "@/views/UserClassifyView"
import Register from "@/views/register";
import AgreementRegister from '@/views/AgreementRegister';
import PrivacyPolicy from '@/views/PrivacyPolicy';
import FeeStandard from '@/views/FeeStandard';

Vue.use(Router)

// 保存原始push和replace方法
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace

// 重写push方法（处理导航重复错误）
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => {
        if (Router.isNavigationFailure(err, Router.NavigationFailureType.duplicated)) {
            return err
        }
        return Promise.reject(err)
    })
}

// 重写replace方法（处理导航重复错误）
Router.prototype.replace = function replace(location, onResolve, onReject) {
    if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
    return originalReplace.call(this, location).catch(err => {
        if (Router.isNavigationFailure(err, Router.NavigationFailureType.duplicated)) {
            return err
        }
        return Promise.reject(err)
    })
}

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'SearchView',
            component: () => import('@/views/SearchView'),
            meta:{title: "全文搜索"}
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
            meta: { title: "登录" }
        },
        {
            path:'/register',
            name:'Register',
            component:Register,
            meta:{ title: "注册"}
        },
        {
            path: '/home',
            name: 'home',
            component: HomeView,
            meta: {
                requiresAuth: true
            }, // 需要登录才能访问
            children: [
                {
                    path: '',
                    name: 'index',
                    component: IndexView,
                    meta: {
                        title: "首页",
                        requiresPermission: 'B0001000'
                    }
                },
                // 信息管理模块
                {
                    path: '/infoManagement',
                    name: 'infoManagement',
                    component: () => import('@/views/Layout.vue'), // 新增布局组件
                    meta: {
                        title: '信息管理',
                    },
                    children: [
                        {
                            path: 'informationEntry',
                            name: 'InformationEntry',
                            component: () => import('@/views/InformationEntryView'),
                            meta: {
                                title: "信息录入",
                                requiresPermission: 'B0002001'
                            }
                        },
                        {
                            path: 'informationEdit',
                            name: 'InformationEdit',
                            component: () => import('@/views/InformationEditView'),
                            meta: {
                                title: "信息编辑",
                                requiresPermission: 'B0002002'
                            }
                        }
                    ]
                },
                //审核管理模块
                {
                    path: '/approveManagement',
                    name: 'approveManagement',
                    component: () => import('@/views/Layout.vue'), // 新增布局组件
                    meta: {
                        title: '审核管理',
                    },
                    children: [
                        {
                            path: 'pendingApprovalList',
                            name: 'pendingApprovalList',
                            component: () => import('@/views/PendingApprovalListView'),
                            meta: {
                                title: "待审核信息",
                                requiresPermission: 'B0003001'
                            }
                        },
                        {
                            path: 'approveFailed',
                            name: 'approveFailedList',
                            component: ApproveFailedListView,
                            meta: {
                                title: "审批未通过",
                                requiresPermission: 'B0003002'
                            }
                        },

                    ]
                },

                {
                    path: '/system',
                    name: 'systemMaintenance',
                    component: () => import('@/views/Layout.vue'),
                    meta: {
                        title: '系统管理',
                    },
                    children: [
                        {
                            path: 'associatedSystem',
                            name: 'associatedSystem',
                            component: () => import('@/views/AssociatedSystemView'),
                            meta: {
                                title: '关联系统管理',
                                requiresPermission: 'B0006001'
                            }
                        },
                        {
                            path: 'category',
                            name: 'categoryManagement',
                            component: CategoryView,
                            meta: {
                                title: '栏目管理',
                                requiresPermission: 'B0006002'
                            }
                        },
                        {
                            path: 'contentManagement',
                            name: 'contentManagement',
                            component: () => import('@/views/ContentManagementView'),
                            meta: {
                                title: '内容管理',
                                requiresPermission: 'B0006003' // 添加权限要求
                            }
                        },

                        {
                            path: 'category/categoryItem',
                            name: 'categoryItem',
                            component: CategoryItemView,
                            props: route => ({
                                parentId: route.query.parentId,
                                parentName: route.query.parentName,
                                categoryName: route.query.categoryName
                            }),
                            meta: {
                                title: '分类专栏管理-子集',
                                requiresPermission: 'B0006002'
                            }
                        }
                    ]
                },
                {
                    path: '/user',
                    name: 'userManagement',
                    component: () => import('@/views/Layout.vue'),
                    meta: {
                        title: '用户管理',
                    },
                    children: [
                        {
                            path: 'userClassify',
                            name: 'userClassify',
                            component: UserClassifyView,
                            meta: {
                                title: '用户栏目权限管理',
                                requiresPermission: 'B0007001'
                            }
                        },
                        {
                            path: 'adminCategory',
                            name: 'adminCategory',
                            component: () => import('@/views/AdminCategoryView'),
                            meta: {
                                title: '栏目范围管理',
                                requiresPermission: 'B0007002'
                            }
                        }
                    ]
                },

                {
                    path: 'knowledge',
                    name: 'knowledgeManagement',
                    component: KnowledgeView,
                    meta: { title: '知识管理' }
                }
            ]
        }
    ]
})